import { logAppError } from 'Helpers/logger'
import {
  generatePreview,
  getAvailableActions,
  getCollaborationProjectUrl,
  getFilters,
  getGroups,
  getListActivation,
  getMandatorySenderAction,
  getMessageActivation,
  getMessageDetails,
  getMessageDynamicContents,
  getPreviewReferenceRecipient,
  isSendingMessage,
  searchRecipients,
  updatePreviewReferenceRecipient
} from '../actions/actions'
import { modalSendingMessageState } from '../state/modals'
import {
  filtersState,
  groupsState,
  previewLastSelected,
  previewState
} from '../state/preview'

import {
  LOGIN_TYPE_WEBLOGIN,
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/index'

import { storeGet } from 'Helpers/localStorage'
import { notifyOpener } from 'Helpers/notifyParent'
import {
  STORE_KEY_FEATURES,
  STORE_KEY_ID_LIST
} from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

import { TOAST_VARIANT_WARNING, toastShow } from 'mailup-web-components'

export const MATCH_FILTER_CONDITION_ALL = 'All'
export const EMAIL_OPTOUT_TYPE_ALL = -1
export const SMS_OPTOUT_TYPE_ALL = -1

export const initPreviewCallbacks = ({ snapshot, set }) => async ({
  id,
  crossLists,
  fromOverview
}) => {
  set(previewState, prev => ({
    ...prev,
    loading: true,
    id
  }))

  try {
    const [
      { Subject, Notes, IdList, MessageType, IsBee },
      dynamicContents
    ] = await Promise.all([
      getMessageDetails(id),
      getMessageDynamicContents(id)
    ])

    const idList = storeGet(STORE_KEY_ID_LIST)
    const footerInOverview =
      storeGet(STORE_KEY_FEATURES).indexOf('FooterInOverview') >= 0

    if (footerInOverview) {
      const mandatorySenderData = await getMandatorySenderAction()

      if (
        !mandatorySenderData ||
        !mandatorySenderData.CompanyName ||
        !mandatorySenderData.Address ||
        !mandatorySenderData.City ||
        !mandatorySenderData.StateOrProvince ||
        !mandatorySenderData.PostalCode ||
        !mandatorySenderData.Country ||
        !mandatorySenderData.Phone ||
        !mandatorySenderData.PermissionReminder
      ) {
        toastShow(
          <>
            {getIntl().formatMessage(
              {
                id: 'Load.SavedEmailWizard.PreviewWarningFooter'
              },
              {
                link: chunks => (
                  <a
                    key={chunks}
                    onClick={goToListSetting}
                    data-mu-test='footerwaring-goToListSetting'
                  >
                    {chunks}
                  </a>
                )
              }
            )}
          </>,
          TOAST_VARIANT_WARNING,
          'PreviewWarningFooter',
          true
        )
      }
    }

    const listActivation = await getListActivation(idList)
    if (listActivation.Items && listActivation.Items.length > 0) {
      await initSelectRecipient(set)
    } else {
      const messageActivation = await getMessageActivation(id)
      if (messageActivation.Items && messageActivation.Items.length > 0) {
        await initSelectRecipient(set)
      } else {
        const { Content: content } = await generatePreview(id, {
          IdRecipient: 0,
          Autosave: false,
          DynamicContentIdList: []
        })

        set(previewState, prev => ({
          ...prev,
          content,
          hasPersonalization: false
        }))
      }
    }

    const actions =
      !crossLists &&
      !fromOverview &&
      MessageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
        ? await getAvailableActions(id, IdList, IsBee)
        : []

    set(previewState, prev => ({
      ...prev,
      id,
      idList: IdList,
      isBee: IsBee,
      title: Subject,
      notes: Notes,
      dynamicContents,
      actions
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'initPreviewCallbacks',
      Data: JSON.stringify({ id, crossLists, fromOverview })
    })
    set(previewState, prev => ({
      ...prev,
      loading: false,
      error
    }))
  }
  set(previewState, prev => ({
    ...prev,
    loading: false
  }))
}

function goToListSetting() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  notifyOpener('setCurrentList', [
    idList,
    'form_upd_nl.aspx?tab=mittenti',
    true
  ])

  window.opener && window.close()
}

async function initSelectRecipient(set) {
  set(previewState, prev => ({
    ...prev,
    hasPersonalization: true,
    showPersonalization: true
  }))

  const groups = await getGroups()
  set(groupsState, groups)

  const filters = await getFilters()
  set(filtersState, filters)

  const idList = storeGet(STORE_KEY_ID_LIST)
  const previewReferenceRecipient = await getPreviewReferenceRecipient(idList)

  let lastFilters = []
  let lastGroups = []
  let lastEmails = []

  if (previewReferenceRecipient) {
    lastGroups = buildLastElementList(
      previewReferenceRecipient.lastGroups,
      [
        ...groups,
        {
          label: getIntl().formatMessage({
            id: 'Load.SearchRecipients.nessunGruppo'
          }),
          value: 0
        }
      ],
      previewReferenceRecipient.lastTypeSelected === 'group'
    )
    lastFilters = buildLastElementList(
      previewReferenceRecipient.lastFilters,
      filters.options,
      previewReferenceRecipient.lastTypeSelected === 'filter'
    )
    lastEmails = buildLastElementList(
      previewReferenceRecipient.lastEmails,
      undefined,
      previewReferenceRecipient.lastTypeSelected === 'email'
    )

    set(previewLastSelected, prev => ({
      ...prev,
      lastGroups,
      lastFilters,
      lastEmails,
      previewReferenceRecipient
    }))
  }
}

const buildLastElementList = (list, fullList, selected) => {
  try {
    const result = []
    list.map((idElement, index) => {
      if (idElement != null) {
        let labels = []
        if (fullList) {
          labels = fullList.filter(
            listElement => listElement.value === idElement
          )
        }

        result.push({
          id: idElement,
          value: labels.length > 0 ? labels[0].label : idElement,
          selected: selected && index === 0
        })
      }
    })
    return result
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'buildLastElementList',
      Data: JSON.stringify({ list, fullList, selected })
    })
  }
  return []
}

export const updateDynamicContentsCallback = ({
  snapshot,
  set
}) => async withDynamicContents => {
  set(previewState, prev => ({
    ...prev,
    loading: true
  }))

  const { id, IdRecipient } = await snapshot.getPromise(previewState)

  try {
    const { Content: content } = await generatePreview(id, {
      IdRecipient,
      Autosave: false,
      DynamicContentIdList: withDynamicContents
    })

    set(previewState, prev => ({
      ...prev,
      content,
      selectedDynamicContents: withDynamicContents
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'updateDynamicContentsCallback',
      Data: JSON.stringify({ withDynamicContents })
    })
    set(previewState, prev => ({
      ...prev,
      loading: false,
      error
    }))
  }

  set(previewState, prev => ({
    ...prev,
    loading: false
  }))
}

export const editMessageCallback = ({ snapshot, set }) => async source => {
  set(previewState, prev => ({
    ...prev,
    loading: true
  }))

  const { id, idList, isBee } = await snapshot.getPromise(previewState)

  try {
    const isSending = await isSendingMessage(id)
    if (isSending) {
      set(modalSendingMessageState, { show: true })
    } else {
      const redirectUrl = isBee
        ? `messages_app_redirector.aspx?r=/messages/email/bee/edit/${id}`
        : `form_upd_newsletter.aspx?source=${source}&idNL=${id}`
      notifyOpener('setCurrentList', [idList, redirectUrl, true])

      window.opener && window.close()
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'editMessageCallback',
      Data: JSON.stringify({ source })
    })
    set(previewState, prev => ({
      ...prev,
      error
    }))
  }

  set(previewState, prev => ({
    ...prev,
    loading: false
  }))
}

export const openCollaborationCallback = ({ snapshot, set }) => async () => {
  set(previewState, prev => ({
    ...prev,
    loading: true
  }))
  const { id, title } = await snapshot.getPromise(previewState)

  try {
    const collaborationUrl = await getCollaborationProjectUrl(id, title)

    window.open(collaborationUrl, '_blank', 'noopener,noreferrer')
    window.opener && window.close()
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'openCollaborationCallback',
      Data: JSON.stringify({ id, title })
    })
    set(previewState, prev => ({
      ...prev,
      error
    }))
  }

  set(previewState, prev => ({
    ...prev,
    loading: false
  }))
}

export const searchRecipientsCallback = ({ set, snapshot }) => async (
  search,
  preferenceRecipient,
  dynamicFields
) => {
  const { previewReferenceRecipient } = await snapshot.getPromise(
    previewLastSelected
  )
  const groups = [
    ...(await snapshot.getPromise(groupsState)),
    {
      label: getIntl().formatMessage({
        id: 'Load.SearchRecipients.nessunGruppo'
      }),
      value: 0
    }
  ]
  const { options: filters } = await snapshot.getPromise(filtersState)

  set(previewState, prev => ({
    ...prev,
    loading: true
  }))

  const defaultSearchState = {
    channel: undefined,
    status: undefined,
    email: '',
    phonePrefix: '',
    phoneNumber: '',
    includeGroups: [],
    excludeGroups: [],
    applyFilters: [],
    applyFiltersOr: MATCH_FILTER_CONDITION_ALL,
    matchFieldsMap: new Map(),
    matchFields: [],
    matchFieldsValues: [],
    subscribedFrom: null,
    subscribedTo: null,
    reqSubscribedFrom: null,
    reqSubscribedTo: null,
    unsubscribedFrom: null,
    unsubscribedTo: null,
    optOutTypeEmail: EMAIL_OPTOUT_TYPE_ALL,
    optOutTypeSms: SMS_OPTOUT_TYPE_ALL,
    optOutMessage: 0,
    orderBy: 'Email',
    orderDescending: true,
    advancedSearchExpanded: false,
    pageSize: 50
  }

  try {
    const results = await searchRecipients(
      { ...defaultSearchState, ...search },
      dynamicFields
    )

    const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
    if (loginType === LOGIN_TYPE_WEBLOGIN && preferenceRecipient) {
      const updateUserResult = await updatePreviewReferenceRecipient({
        ...previewReferenceRecipient,
        ...preferenceRecipient
      })

      set(previewLastSelected, prev => ({
        ...prev,
        previewReferenceRecipient: JSON.parse(updateUserResult.DataValue)
      }))

      await initSelectRecipient(set)
    }

    if (results.TotalItems > 0) {
      const max = results.TotalItems < 50 ? results.TotalItems - 1 : 49
      const randomIndex = Math.floor(Math.random() * (max + 1))
      const idUser = results.Items[randomIndex].id
      const recipient = results.Items[randomIndex].fields.get('Email')

      let tooltip
      if (search) {
        if (search.includeGroups) {
          tooltip = {
            value: groups.find(g => g.value === search.includeGroups[0]).label,
            type: 'group'
          }
        }
        if (search.applyFilters) {
          tooltip = {
            value: filters.find(f => f.value === search.applyFilters[0]).label,
            type: 'filter'
          }
        }
      }

      await updatePreviewFromSelectedRecipient(
        set,
        snapshot,
        idUser,
        recipient,
        tooltip
      )
    }

    set(previewState, prev => ({
      ...prev,
      loading: false
    }))

    return results
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'searchRecipientsCallback',
      Data: JSON.stringify({ search, preferenceRecipient, dynamicFields })
    })

    set(previewState, prev => ({
      ...prev,
      loading: false
    }))
  }
}

async function updatePreviewFromSelectedRecipient(
  set,
  snapshot,
  IdRecipient,
  recipient,
  tooltip
) {
  const { id } = await snapshot.getPromise(previewState)

  const { selectedDynamicContents, autoSave } = await snapshot.getPromise(
    previewState
  )

  set(previewState, prev => ({
    ...prev,
    active: true,
    loading: true
  }))

  try {
    const { Content } = await generatePreview(id, {
      IdRecipient: IdRecipient,
      Autosave: !!autoSave,
      DynamicContentIdList: selectedDynamicContents
    })

    set(previewState, prev => ({
      ...prev,
      active: true,
      loading: false,
      showPersonalization: false,
      content: Content,
      IdRecipient,
      recipient,
      tooltip
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'PreviewMessage',
      Method: 'updatePreviewFromSelectedRecipient',
      Data: JSON.stringify({ IdRecipient, recipient, tooltip })
    })

    set(previewState, prev => ({
      ...prev,
      active: true,
      loading: false,
      error: true
    }))
  }
}
